import * as React from "react";
import { BalanceUpdateReceivedFromUserDetailsFragmentFragment } from "../../../hooks/useTransactions/graphql/TransactionsFragment.generated";
import { Trans } from "react-i18next";
import { usePlayerProfile } from "../../PlayerProfile";
import { GAME_IDS } from "../../Games";

export const BalanceUpdateReceivedFromUserDetails = ({
  details,
}: {
  details: BalanceUpdateReceivedFromUserDetailsFragmentFragment;
}) => {
  const openProfile = usePlayerProfile();
  return (
    <Trans i18nKey="transaction.BalanceUpdateReceivedFromUserDetails_details">
      Received credits from{" "}
      <button
        onClick={() =>
          openProfile({
            id: details.userId,
            name: details.name,
            games: GAME_IDS,
            tournament: false,
          })
        }
      >
        <strong>{{ user: details.name }}</strong>
      </button>
    </Trans>
  );
};
